import _overRest from 'lodash-es/_overRest';
import identity from 'lodash-es/identity';

// Lodash rest function without function.toString()
// remappings
export default function rest(func, start) {
    return _overRest(func, start, identity);
}



// WEBPACK FOOTER //
// ../../../../~/async-es/internal/rest.js